import React, { useState } from 'react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'El acceso es inmediato. Apenas se confirma tu pago, recibís un email con el link para descargar todo el pack en tu celular, tablet o computadora.'
}, {
  q: '¿Sirve si soy docente principiante?',
  a: '¡Totalmente! Es ideal para darte seguridad en tus primeras clases. Tenés la estructura armada, las actividades paso a paso y las rúbricas listas para usar.'
}, {
  q: '¿Para qué niveles educativos sirve?',
  a: 'El pack cubre todo Primaria (tomos 1 al 6) y toda Secundaria (1° a 6° año), con una progresión clara y adaptable a cada grupo.'
}, {
  q: '¿Los bonos están incluidos en el precio?',
  a: 'Sí, los 6 bonos exclusivos están incluidos 100% gratis con tu compra de hoy, sin costo adicional.'
}, {
  q: '¿En qué formato están los archivos?',
  a: 'Todo el material está en formato PDF de alta calidad, listo para leer en cualquier dispositivo o para imprimir si preferís el papel.'
}, {
  q: '¿Tengo que pagar una mensualidad?',
  a: 'No, es un pago único. Una vez que lo comprás, el material es tuyo para siempre. No hay suscripciones ni cobros ocultos.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si sentís que el material no te sirve, nos mandás un email y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-alt py-20 sm:py-24 px-4" data-id="element-73">
      <div className="max-w-3xl mx-auto" data-id="element-74">
        <div className="text-center mb-12" data-id="element-75">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-76">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-bg-main border border-border-light rounded-2xl overflow-hidden" data-id="element-78">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-79">
                  <span className="font-bold text-text-main text-lg" data-id="element-80">
                    {faq.q}
                  </span>
                  <span className={`text-2xl text-primary transition-transform ${isOpen ? 'rotate-45' : ''}`} data-id="element-81">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-82">
                  <p className="text-text-sec text-base" data-id="element-83">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}